// 'none' hides the save-status pill entirely: a brand-new untouched template is
// neither dirty nor saved.
export type SaveStatus = 'unsaved' | 'saved' | 'none';

export type SaveStatusInput = {
  isDirty: boolean;
  isPersisted: boolean;
};

export const resolveSaveStatus = (input: SaveStatusInput): SaveStatus => {
  if (input.isDirty) return 'unsaved';
  return input.isPersisted ? 'saved' : 'none';
};
